import { b2x } from '@b2x/react/src';
import classnames from 'classnames';

export interface PageProps extends b2x.PageProps {}

export const Page = ({ className, ...otherProps }: PageProps) => {
  return <b2x.Page {...otherProps} className={classnames(className, 'h-100')} />;
};
